import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const showWork = listeners["showWork"] || function () { };
  const showText = listeners["showText"] || function () { };
  const Deal = ({ props: { vo } }) => {
    let dealConf = []

    if (vo.row.isOnline) {
      dealConf = [
        [
          "考试详情",
          "classStatistics:test",
          "icon-message",
          () => { showText(vo.row.uuid) }
        ],
        [
          "作业详情",
          "classStatistics:work",
          "icon-preview",
          () => { showWork(vo.row.uuid) }
        ]
      ]
    } else {
      dealConf = [
        [
          "考试详情",
          "classStatistics:test",
          "con-message-disable",
          () => { }
        ],
        [
          "作业详情",
          "classStatistics:work",
          "icon-preview-disable",
          () => { }
        ]
      ]
    }


    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            v-permission={item[1]}
            placement="top"
          >
            <i class={item[2]} onClick={item[3]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const tableConfig = [
    {
      label: "班级名称",
      prop: "className",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "班级分类",
      prop: "trainTypeName",
      minWidth: "60",
      showOverflowTooltip: true
    },
    {
      label: "培训时间",
      prop: "trainTimeStr",
      minWidth: "120",
      showOverflowTooltip: true
    },

    {
      label: "总学习人数",
      prop: "totalNum",
      minWidth: "60",
      showOverflowTooltip: true,
    },
    {
      label: "已结业人数",
      prop: "graduationNum",
      minWidth: "60",
      showOverflowTooltip: true
    },
    {
      label: "结业率",
      prop: "graduationRate",
      minWidth: "60",
      showOverflowTooltip: true
    },
    // {
    //   label: "考试平均分",
    //   prop: "collectCount",
    //   minWidth: "100",
    //   showOverflowTooltip: true,
    // },
    // {
    //   label: "作业完成率%",
    //   prop: "collectCount",
    //   minWidth: "100",
    //   showOverflowTooltip: true,
    // },
    {
      label: "操作",
      width: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      talbeCols={tableConfig}
    />
  );
};

export default Table;
